



























import BaseSection from '@/ui/BaseSection.vue';

export default {
    name: 'TheWelcomeFood',
    components: {
        BaseSection,
    },
};
